module.exports = __webpack_public_path__ + "assets/assets/images/icons/x-icon.30b93794.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/x-icon.svg
// module id = 280
// module chunks = 2